var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DividedList',{attrs:{"items":_vm.committeeGroups,"empty-message":_vm.$t('no_committee_groups_existing'),"list-item":_vm.CommitteeGroupListItem}})
}
var staticRenderFns = []

export { render, staticRenderFns }